import * as React from "react";

function SvgIcSize(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <defs>
        <clipPath id="i0">
          <path d="M1.77777778,0 L1.77777778,17.7777778 L0,17.7777778 L0,0 L1.77777778,0 Z M20.9082126,0 L20.9082126,17.7777778 L19.1304348,17.7777778 L19.1304348,0 L20.9082126,0 Z M13.9461804,4.07633051 L18.6541179,8.88888889 L13.9461804,13.7014473 L12.6753643,12.4582577 L15.297,9.777 L5.61,9.777 L8.23284824,12.4582577 L6.96203219,13.7014473 L2.25409464,8.88888889 L6.96203219,4.07633051 L8.23284824,5.31952012 L5.609,8 L15.299,8 L12.6753643,5.31952012 L13.9461804,4.07633051 Z" />
        </clipPath>
      </defs>
      <g transform="translate(1.5458937198067382 3.1111111111111107)">
        <g clipPath="url(#i0)">
          <polygon
            points="0,0 20.9082126,0 20.9082126,17.7777778 0,17.7777778 0,0"
            stroke="none"
            fill="#444444"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgIcSize;
